import {
  HomepageContext,
  HomepageProvider,
} from '@components/Providers/HomepageProvider';
import {
  HomepageCandidates,
  HomepageHeader,
  HomepageJobs,
} from '@components/Homepage/index';
import Footer from '@components/Footer/Footer';
import React from 'react';
import { HomepageLoader } from '@app/loaders/HomepageLoader';
import { Route, Routes } from 'react-router-dom';

export const Homepage = () => (
  <HomepageProvider>
    <HomepageContext.Consumer>
      {context =>
        context.isLoading ? (
          <HomepageLoader />
        ) : (
          <>
            <HomepageHeader />

            <Routes>
              <Route path="/candidates" element={<HomepageCandidates />} />

              <Route
                path="/customers/:customerId?/candidates"
                element={<HomepageCandidates />}
              />

              <Route path="/" element={<HomepageJobs />} />

              <Route
                path="/customers/:customerId?"
                element={<HomepageJobs />}
              />
            </Routes>

            <div className="rev-o-container">
              <Footer
                logo={`${__ENVIRONMENT_CONFIG__.PUBLIC_URL}/assets/images/logo/reverse-group-logo.svg`}
              />
            </div>
          </>
        )
      }
    </HomepageContext.Consumer>
  </HomepageProvider>
);
